import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePublicationRequest } from "../api/publicationRequestsApi";

export function useDeletePublicationRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deletePublicationRequest(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["publication-requests"] }),
  });
}
